// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"b997161a","198":"34f268e4","200":"b13bd259","326":"437af7a7","357":"2aa6c181","446":"cf955865","565":"41c5731f","639":"ee562bdc","748":"a70d6cbe","766":"992642a5","928":"22219f8c","971":"f390b926"}[chunkId] + ".chunk.js";
};